(function () {
    'use strict';

    a3_cabin_reports.controller('CalendarCtrl', CalendarCtrl);

    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name CalendarCtrl
     * @description 
     *   View your schedule (flights and ground duties)
     * @ngInject
     */
    function CalendarCtrl($scope, defaultCalendarDate, LeaveRequestFactory, version, $location,
        FlightFactory, UserFactory, MemoFactory, MessageFactory, UpdateService,
        SyncLogFactory, $timeout, $uibModal, CrewRouteFactory, CrewHotelFactory, GroundDutyFactory,
        localStorageMD5Service, SettingsMain, TrainingSessionFactory, FlightSessionFactory,
        ScheduleAcknowledgeFactory, CheckInFactory, ExpiriesFactory, $route, TraineeCoursesDetailsFactory,
        RequestFactory, SaFeedbackInfoFactory) {

        var flights = FlightFactory.getFlightsFromStorage();
        var user = UserFactory.getUser();
        var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();

        $scope.isSecure = UserFactory.isSecure();
        $scope.state = 'calendar'; 
        $scope.setupView = setupView;
        $scope.logged_user_info = user.aimsId + ' - ' + user.name;
        $scope.storageUsage = storageUsage();
        $scope.addFlight = addFlight;
        $scope.openSynch = openSynch;
        $scope.pendingOverdueReports = 0;
        $scope.draftReports = 0;
        $scope.completedReports = 0;
        $scope.isUserSA = user.position == 'SA' ? true : false;
        $scope.gotoUnreadMemos = gotoUnreadMemos;
        $scope.gotoMessages = gotoMessages;
        $scope.gotoLeaves = gotoLeaves;
        $scope.hasUnsetTraining = false;
        $scope.hasScheduleChanged = false;
        $scope.acknowledge = acknowledge;
        $scope.showPasswordExpiryAlert = false;
        $scope.showExpiriesAlertCalendar = false;
        $scope.showSubmissionDeadlineAlertCalendar = false;
        $scope.expiryList = [];
        $scope.expiredExpiriesList = [];
        $scope.submissionDeadline = null;
        $scope.showCheckInAction = false;
        $scope.openCheckIn = openCheckInModal;
        $scope.searchPastGroundDuties = searchPastGroundDuties;
        $scope.hasManualEntry = false;
        $scope.gotoGroundDutyInfo = gotoGroundDutyInfo;
        $scope.removeManualEntry = removeManualEntry;
        $scope.daysDiff = daysDiff;
        $scope.hasTraineeCourse = false;
        $scope.gotoFlightInfo = gotoFlightInfo;

        $scope.removeFlightTrainingManualEntry = removeFlightTrainingManualEntry;
        $scope.gotoCrewRouteInfo = gotoCrewRouteInfo;

        $scope.pastTrainingsViewSummary = pastTrainingsViewSummary;
        $scope.viewPastTrainings = false;
        $scope.removePendingGDEntry = removePendingGDEntry;
        $scope.removePendingFlightEntry = removePendingFlightEntry;

        $scope.showExpiredExpiriesAlertCalendar = false;

        $scope.passwordExpiry = {
            showAlert: false,
            lastChange: null,
            daysLeft: null  
        };
        
        function pastTrainingsViewSummary() {
            $scope.viewPastTrainings = ! $scope.viewPastTrainings
        }
        var groundSessions = [];
        var flightSessions = [];
        TrainingSessionFactory.getAll(function (savedGroundSessions) {
            FlightSessionFactory.getAll(function (savedFlightSessions) {
                groundSessions = savedGroundSessions;
                flightSessions = savedFlightSessions;

                $scope.setupView(false);
            });
        });

        if (version) {
            $scope.version = version.replace('appVersion_', '');
        } else {
            $scope.version = '';
        }

        /**
         * Calculates the local storage Usage
         * @memberof CalendarCtrl
         * @return {string} usage
         */
        function storageUsage() {
            var usage = localStorageMD5Service.usedSize();
            return usage;
        }

        /**
         * Calculates days left
         * @memberof CalendarCtrl
         * @return {string} usage
         */
        function daysDiff(date) {
            var today = moment().startOf('day');
            var expiryDate = moment(date);

            return expiryDate.diff(today, 'days');
        }

        /**
         * Setups Calendar View
         * @memberof CalendarCtrl
         * @param {boolean} isReload
         */
        function setupView(isReload) {
            if (!UserFactory.isLoggedIn()) {
                $location.path("/login");
            }

            $scope.NeedsToSync = UpdateService.updater();

            $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;

            $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();

            $scope.leaveRequest = LeaveRequestFactory.getLeaveRequestInformation();

            $scope.leaveRequestCloseDate = $scope.leaveRequest ? moment($scope.leaveRequest.CloseDate).format('Do of MMMM') : null;

            $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
            
            $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();

            //Get count of unread memos but remove the ones that belong in 'Training Surveys' Category
            MemoFactory.getUnreadMemos(function (memos) {
                $scope.unreadMemosCount = (memos && memos.length) || 0;
            });

            // read the flights from the local storage and display them
            var flights = FlightFactory.getFlightsFromStorageAndCheckIfTooOld();

            // also load the flights created by the user
            flights = FlightFactory.getLocalFlightsAndMergeWithServerFlights(flights);

            // if no local flights are found then force sync
            if (!isReload) {
                needsToSync = true;
            }

            var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
            var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
            var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
            var crewRoutesEvents = formatCrewRoutes(crewRoutes);     
            
            var traineeGroundCourses = TraineeCoursesDetailsFactory.getTraineeCourses();

            var groundDutiesEvents = formatGroundDuties(groundDuties, traineeGroundCourses);       
          
            // Get incomplete past duties
            $scope.totalIncompleteGD = [];
            $scope.totalIncompleteGD = groundDuties.filter(x => x.isManualEntry == true && !x.hasPendingCourse);

  
            // Flight duties
            $scope.totalIncompleteFlightDuties = [];
            $scope.totalIncompleteFlightDuties = crewRoutes.filter(x => x.isManualEntry && !x.hasPendingCourse);
        
            //
        
            if($scope.totalIncompleteGD.length > 0 || $scope.totalIncompleteFlightDuties.length > 0){
                $scope.showPastTrainingsSummary = true;
            }

            // Used for pending trainings notification        
            $scope.manualGroundDuties = GroundDutyFactory.getManualGroundDutiesFromStorage();
            findManualEntries($scope.manualGroundDuties);

            $scope.manualFlightTrainings = CrewRouteFactory.getManualFlightTrainingsFromStorage();
            findManualFlightTrainingEntries($scope.manualFlightTrainings);
        
            var traineeFlightCourses = TraineeCoursesDetailsFactory.getFlightCourses();
            var flightEvents = formatFlights(flights, traineeFlightCourses);

            var crewHotelsEvents = formatHotels(crewHotels);

            var events = flightEvents.concat(groundDutiesEvents).concat(crewRoutesEvents).concat(crewHotelsEvents);

            var specialDates = findScheduleChangedDates();

            $scope.events = events;

            calendar(events, specialDates);
        
            var needsToSync = false;

            // check the last sync date
            var lastLog = SyncLogFactory.getSyncLog();
            var canShowSync = true;
            if (lastLog == null) {
                needsToSync = true;
            } else {
                canShowSync = lastLog.canShowSync(); //used to avoid showing again and again the dialog :: delay X minutes before showing again
                if (lastLog.date == null)
                    needsToSync = true;
                else if (lastLog.date != null) {
                    if (Date.today().add(-1).days().toUTC().isAfter(new Date(lastLog.date).toUTC()) || lastLog.forceSync) {
                        if (!isReload)
                            needsToSync = true;
                    }
                }
            }

            var isOpenUpdateModal = ($(".modal-updating").data('bs.modal') || { isShown: false }).isShown;
            if (needsToSync && canShowSync && !isOpenUpdateModal) {
                $scope.openSynch();
            } else {
                MemoFactory.getMandatoryUnreadMemos(function (memos) {
                    $scope.mandatoryUnread = memos.length;
                    if ($scope.mandatoryUnread > 0) {
                        openMandatoryModal();
                    }
                });
            }

            $scope.showExpiriesAlertCalendar = showExpiriesAlertCalendar();
            $scope.showSubmissionDeadlineAlertCalendar = showSubmissionDeadlineAlertCalendar();

          // Expired Expiries
            $scope.showExpiredExpiriesAlertCalendar = false;
            $scope.expiredExpiriesList = [];

            ExpiriesFactory.getExpiredExpiries().then(function (list) {
                $scope.expiredExpiriesList = list || [];
                $scope.showExpiredExpiriesAlertCalendar = $scope.expiredExpiriesList.length > 0;
            }, function () {
                $scope.expiredExpiriesList = [];
                $scope.showExpiredExpiriesAlertCalendar = false;
            });

            $scope.showCheckInAction = showCheckInAction();
            preparePasswordExpiryData();
            showReminderModal();
        }


        /**
         * Finds the dates with a change on their schedule
         * @memberof CalendarCtrl
         * @return {array} scheduleChangedDates
         */
        function findScheduleChangedDates() {
            var scheduleChangedDates = ScheduleAcknowledgeFactory.getScheduleChangesFromStorage();
            $scope.hasScheduleChanged = scheduleChangedDates.some(s => s);

            return scheduleChangedDates;
        }

        /**
         * Finds the dates with manual pending training entries on their schedule
         * @memberof CalendarCtrl        
         */
        function findManualEntries(manualDuties) {
            for (var i = 0; i < manualDuties.length; i++) {
                if (manualDuties[i].hasPendingCourse) {
                    $scope.hasManualEntry = true;
                    break;
                }
            }
        }

        function findManualFlightTrainingEntries(manualFlightTrainings) {           
            for (var i = 0; i < manualFlightTrainings.length; i++) {
                if (manualFlightTrainings[i].hasPendingCourse) {
                    $scope.hasManualEntry = true;
                    break;
                }
            }
        }
        
        /**
         * Initialize Calendar
         * @memberof CalendarCtrl
         * @param {array} events Flights and Ground duties 
         * @param {array} specialDates The Schedule Changed Dates
         */
        function calendar(events, specialDates) {
            $("#calendar").fullCalendar({
                defaultView: getDefaultView(),
                defaultDate: defaultCalendarDate,
                firstDay: 1,
                lang: 'en',
                editable: false,
                draggable: false,
                selectable: false,
                selectHelper: false,
                unselectAuto: false,
                disableResizing: false,
                droppable: false,
                fixedWeekCount: false,
                nextDayThreshold: "00:00:00",
                header: {
                    left: 'title',
                    center: '',
                    right: 'month,listMonth today prev,next'
                },
                timeFormat: 'HH:mm',
                displayEventEnd: true,
                events: events,
                eventRender: function (event, element, icon) {
                    if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
                        element.find('.fc-list-item-title').addClass('listview-icon');
                        $.each(event.className, function (index, icon) {
                            element.addClass(event.listViewColor);
                        });
                        // $.each(event.icons, function (index, icon) {
                        //     element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
                        // });


                        if (!event.description == "") {
                            element.find('.fc-list-item-title').append("<span>" + "  " + event.description + "</span>");
                        }
                        if (!event.icon == "") {
                            element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.icon + " '></i>");
                        }
                        if (!event.second_icon == "") {
                            element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.second_icon + " '></i>");
                        }
                        if(!event.third_icon == "") {
                            element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.third_icon + " '></i>");
                        }
                    } else {
                        if (event.type == "crewRoute" || event.type == "hotel") {                            
                            element.find('.fc-time').remove();
                        }

                        element.find('.fc-title').prepend("<br/>");
                        if (!event.description == "") {
                            if(event.routeIndicators && event.routeIndicators.length >0){
                                var routeIndicatorLetters = "";
                                for (var j = 0; j < event.routeIndicators.length; j++) {
                                    var letter = "<strong class='pull-right " + event.routeIndicators[j].routeIndicatorColor +"'>" + event.routeIndicators[j].routeIndicatorCode +"</strong>";
                                    routeIndicatorLetters = routeIndicatorLetters + letter;
                                }

                                element.find('.fc-title').append(
                                    "<br/><span class='calendar-light'>" + event.description + "</span>" + 
                                    routeIndicatorLetters +
                                    "<br/>");
                            }
                            else{
                                element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span> <br/>");
                            }
                        }
                        if (!event.icon == "") {
                            element.find('.fc-title').append("<i class='calendar-icon fa " + event.icon + " '></i>");
                        }
                        if (!event.second_icon == "") {
                            element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.second_icon + " '></i>");
                        }
                        if(!event.third_icon == "") {
                            element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.third_icon + " '></i>");
                        }
                    }

                },
                dayRender: function (date, cell) {
                    for (var i = 0; i < specialDates.length; i++) {
                        var objdate = new Date(specialDates[i]);
                        if ((date._d.getFullYear() == objdate.getFullYear()) &&
                            (date._d.getDate() == objdate.getDate()) &&
                            (date._d.getMonth() == objdate.getMonth())
                        )
                            cell.addClass('bg-yellow');
                    }
                },
                dayClick: function (date, jsEvent, view) { },
                eventClick: function (calEvent, jsEvent, view) {
                    if (calEvent.type == "flight") {
                        $timeout(function () {
                            gotoFlightInfo(calEvent._id);
                        });
                    } else if (calEvent.type == "groundDuty") {
                        $timeout(function () {
                            gotoGroundDutyInfo(calEvent._id);
                        });
                    } else if (calEvent.type == "crewRoute") {
                        $timeout(function () {
                            gotoCrewRouteInfo(calEvent.dutyNo, calEvent.dutyDay);
                        });
                    }
                },
                height: 'auto'
            });

            function getDefaultView() {
                var calendarStyle = SettingsMain.getCalendarViewStyle();
                if (calendarStyle == null) {
                    calendarStyle = detectMobile() ? "listMonth" : "month";
                }
                return calendarStyle;

            }

            function detectMobile() {
                var isMobile = (window.innerWidth <= 800 && window.innerHeight <= 735);

                return isMobile;
            }

            $('.fc-listMonth-button').click(function () {
                SettingsMain.setCalendarViewStyle('listMonth');
            })

            $('.fc-month-button').click(function () {
                SettingsMain.setCalendarViewStyle('month');
            })

        }

        /**
         * Transform flights in calendar events
         * @memberof CalendarCtrl
         * @param {array} flights The Scheduled Flights 
         * @return {array} events 
         */
        function formatFlights(flights, traineeFlightCourses) {
            var flightEvents = [];
         

            for (var i = 0; i < flights.length; i++) {
                var description = flights[i].getRoute();
                var title = flights[i].FlightNo;
                var third_icon ="";
                var flightCourseStatuses = [];
                var flightCoursesFlat = [];
                if (flights[i].TrainingIndicatorCode) {
                    title = title + " " + flights[i].TrainingIndicatorCode;
                }

                /* Trainee flight courses */
           
                var relatedFlightTraineeCourses = [];
                for (var j = 0; j < traineeFlightCourses.length; j++){
                    if(flights[i].IsTrainee == true && flights[i].FlightId == traineeFlightCourses[j].FlightId) {
                        relatedFlightTraineeCourses = traineeFlightCourses.find(x => x.FlightId == flights[i].FlightId);
                                  
                        flightCoursesFlat = flightCoursesFlat.concat(relatedFlightTraineeCourses);
                   
                   
                    /*  NotSet = 0,
                        InProgress = 1,
                        Completed = 2,
                        Pending = 3,
                        NeedsApproval = 4,
                        NotCompleted = 5 
                    */
                    }
                 
                    if(flightCoursesFlat.length > 0){
                        console.log(relatedFlightTraineeCourses);
                        console.log(flightCourseStatuses);
                    }
                    
                }
               if (flightCoursesFlat.length > 0) {
                flightCoursesFlat.forEach(function (x) {
                    flightCourseStatuses.push(x.Status);
                  
                });
               }
          
                if (flightCourseStatuses.includes(1)) {
                    //Pending
                    third_icon = "fa-graduation-cap text-blue";
                } else if (flightCourseStatuses.includes(2)) {
                    //Completed
                    third_icon = "fa-graduation-cap text-green";
                }  else if (flightCourseStatuses.includes(4) || flightCourseStatuses.includes(5))  {
                    //Needs approval or stopped
                    third_icon = "fa-graduation-cap text-orange";
                }

                var classname = "";
                var icon = "fa-plane";
                var second_icon = "";
                var id = flights[i].FlightId;
                var type = "flight";
                var listViewColor = "";

                /*              Weights for status of reports
                                6 --> na
                                5 --> draft
                                4 --> pendingoverdue
                                3 --> pending
                                2 --> completed
                                1 --> synched */

                var CabinReportStatusWeight = 0;
                if (flights[i].LineStatus === 'na')
                    CabinReportStatusWeight = 6;
                else if (flights[i].LineStatus === 'pending')
                    CabinReportStatusWeight = 3;
                else if (flights[i].LineStatus === 'pendingoverdue') {
                    CabinReportStatusWeight = 4;
                    $scope.pendingOverdueReports++;
                } else if (
                    (flights[i].LineStatus === 'draft') ||
                    (flights[i].LineStatus === 'draftotheruser')
                ) {
                    $scope.draftReports++;
                    CabinReportStatusWeight = 5;
                } else if (
                    (flights[i].LineStatus === 'completed') ||
                    (flights[i].LineStatus === 'completedotheruser')
                ) {
                    $scope.completedReports++;
                    CabinReportStatusWeight = 2;
                } else if (
                    (flights[i].LineStatus === 'stored') ||
                    (flights[i].LineStatus === 'storedotheruser') ||
                    (flights[i].LineStatus === 'stored+otheruser') ||
                    (flights[i].LineStatus === 'synched') ||
                    (flights[i].LineStatus === 'synchedotheruser')
                ) {
                    CabinReportStatusWeight = 1;
                }

                var faAssessmentStatusWeight = 0;
                if (isAssessmentEnabled && flights[i].assessment){
                    if(flights[i].assessment.IsExist || flights[i].assessment.Status == 'Stored' || flights[i].assessment.Status == 'Synched'){
                        faAssessmentStatusWeight = 1
                    }else if(flights[i].assessment.Status == 'Completed'){
                        faAssessmentStatusWeight = 2;
                    }else if(flights[i].assessment.Status == 'Pending'){
                        faAssessmentStatusWeight = 3;
                    }else if(flights[i].assessment.Status == 'Draft'){
                        faAssessmentStatusWeight = 5;
                    }
                }
                   
                var saAssessmentStatusWeight = 0;

                if (isAssessmentEnabled && flights[i].saAssessment) {
                    var nowUtc = moment();
                    if(defaultCalendarDate){
                        nowUtc = moment(defaultCalendarDate);
                    }
                    // Check if the assessment is outdated
                    var isOutDated = flights[i].saAssessment.LatestEndPeriod ? 
                            moment(flights[i].saAssessment.LatestEndPeriod).add(1, 'day').isBefore(nowUtc, 'day') : false;

                    if (flights[i].saAssessment.IsExist || flights[i].saAssessment.Status == 'Stored' || isOutDated) {
                        saAssessmentStatusWeight = 1
                    } else if (flights[i].saAssessment.Status == 'Completed') {
                        saAssessmentStatusWeight = 2;
                    } else if (flights[i].saAssessment.Status == 'Pending') {
                        saAssessmentStatusWeight = 3;
                    } else if (flights[i].saAssessment.Status == 'Draft') {
                        saAssessmentStatusWeight = 5;
                    }
                }

                var assfReportWeight = 0;
                if($scope.isUserSA){ 
                    if (flights[i].assfReport && flights[i].assfReport.isRequired){
                        if(flights[i].assfReport.status == 'Stored'){
                            assfReportWeight = 1
                        }else if(flights[i].assfReport.status == 'Completed'){
                            assfReportWeight = 2;
                        }else if(flights[i].assfReport.status == 'Pending'){
                            assfReportWeight = 3;
                        }else if(flights[i].assfReport.status == 'Draft'){
                            assfReportWeight = 5;
                        }
                    }
                }

                var statusWeight = 0;

                var statusWeightWithoutReport = Math.max(
                    assfReportWeight, 
                    faAssessmentStatusWeight, 
                    saAssessmentStatusWeight || 0
                );
                
                // Compute the maximum:
                if(statusWeightWithoutReport !== 0 && CabinReportStatusWeight == 6){
                    statusWeight = statusWeightWithoutReport;
                }else{
                    statusWeight = Math.max(
                        CabinReportStatusWeight, 
                        assfReportWeight, 
                        faAssessmentStatusWeight, 
                        saAssessmentStatusWeight || 0
                    );
                }

                if (statusWeight == 6) {
                    if (flights[i].IsDHC) {
                        classname = "fc-aluminum";
                        icon = "";
                        listViewColor = "lv-aluminium";
                    } else{
                        classname = "fc-white";
                        icon = "";
                        listViewColor = "lv-white";
                    }
                } else if (statusWeight == 5) {
                    classname = "fc-orange";
                    icon = "fa-pencil";
                    listViewColor = "lv-orange";
                } else if (statusWeight == 4) {
                    classname = "fc-seablue";
                    icon = "fa-exclamation-triangle text-lemon";
                    listViewColor = "lv-seablue";
                } else if (statusWeight == 3) {
                    classname = "fc-blue";
                    icon = "fa-plus";
                    listViewColor = "lv-blue";
                } else if (statusWeight == 2) {
                    classname = "fc-purple";
                    icon = "fa-check-circle";
                    listViewColor = "lv-purple";
                } else if (statusWeight == 1) {
                    classname = "fc-green";
                    icon = "fa-cloud-download";
                    listViewColor = "lv-green";
                }

                if (flights[i].IsScheduleChanged && flights[i].LineStatus != 'na') {
                    classname = classname + " text-yellow-important";
                }

                if (
                    (flights[i].LineStatus === 'draftotheruser') ||
                    (flights[i].LineStatus === 'completedotheruser') ||
                    (flights[i].LineStatus === 'synchedotheruser') ||
                    (flights[i].LineStatus === 'storedotheruser') ||
                    (flights[i].LineStatus === 'stored+otheruser')
                )
                    second_icon = "fa-user";

                var IsScheduleChanged = flights[i].IsScheduleChanged;
                var ScheduledDeparture = flights[i].ScheduledDeparture

                if (flights[i].ScheduledArrival == null) {
                    var ScheduledArrival = ScheduledDeparture;
                } else {
                    var ScheduledArrival = flights[i].ScheduledArrival
                }

                var event = {
                    _id: id,
                    title: title,
                    start: ScheduledDeparture,
                    end: ScheduledArrival,
                    description: description,
                    icon: icon,
                    second_icon: second_icon,
                    className: classname,
                    type: type,
                    isScheduleChanged: IsScheduleChanged,
                    listViewColor: listViewColor,
                    third_icon: third_icon
                };
                flightEvents.push(event)
            }
            return flightEvents;
        }

        /**
         * Transform Ground Duties in calendar events
         * @memberof CalendarCtrl
         * @param {array} duties The Scheduled Ground Duties 
         * @return {array} events 
         */
        function formatGroundDuties(duties, traineeGroundCourses) {
            var groundEvents = [];
            var now = moment.utc();

            for (var i = 0; i < duties.length; i++) {
                var description = duties[i].Code;
                var title = (duties[i].Title) ? duties[i].Title : duties[i].Duty;

                var classname = "fc-white";

                var icon = "";
                var second_icon = "";

                if (duties[i].RelatedGroundDuties && duties[i].RelatedGroundDuties.length > 1) {
                    icon = "fa-graduation-cap" // icon only if training

                    //Get ground courses
                    var courseStatuses = [];
                    var coursesFlat = [];
                    for (var j = 0; j < duties[i].RelatedGroundDuties.length; j++) {
                        /* Trainee ground courses */
                        if(traineeGroundCourses.length > 0){
                            var relatedTraineeCourse = traineeGroundCourses.find(x => x.GroundDutyId == duties[i].Id);
                        }
                        var relatedDutyCourse = duties[i].RelatedGroundDuties[j].Courses;
                                            
                        if (relatedDutyCourse) {
                            coursesFlat = coursesFlat.concat(relatedDutyCourse);
                        }

                        if (relatedTraineeCourse) {
                            coursesFlat = coursesFlat.concat(relatedTraineeCourse);
                        }

                        coursesFlat.forEach(function (x) {
                            courseStatuses.push(x.Status);
                        })
                     
                    }                 
    
                    /*Statuses
                        Completed : session has been sent
                        Outdated  :	session submission is overdue
                        Draft	  : session completion has started but not submitted
                        Pending   : session submission not yet due
                    */                                 

                    /*  NotSet = 0,
                        InProgress = 1,
                        Completed = 2,
                        Pending = 3,
                        NeedsApproval = 4,
                        NotCompleted = 5 
                    */
                    if (courseStatuses.includes("Pending") || courseStatuses.includes(1)) {
                        //Pending
                        classname = "fc-blue-inverted"

                        //Outdated
                        var dutyEnd = moment.utc(duties[i].DutyEnd);
                        var duration = moment.duration(now.diff(dutyEnd)).asHours();
                        if (duration > 1) {
                            if (courseStatuses.includes("Pending") || courseStatuses.includes('1')) $scope.hasUnsetTraining = true;
                            classname = "fc-seablue-inverted"
                            second_icon = "fa-exclamation-triangle text-yellow second-icon-training";
                            // isManualEntry = true;
                        }

                        //Draft
                        var courseId = coursesFlat[0].CourseId; // Fix msis // each duty should contain ONLY ONE COURSE
                        var duty = duties[i];

                        if (groundSessions && groundSessions.length) {
                            var existingSession = groundSessions.find(s => s.courseId == courseId && s.day == duty.DutyDateS && s.dutyId == duty.Id);
                            if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                                //a training session with trainees exists
                                classname = "fc-orange-inverted";
                                icon = "fa-graduation-cap";
                                second_icon = "";
                                // isManualEntry = true;
                            }
                        }
                    } else if (courseStatuses.includes("Completed") || courseStatuses.includes(2)) {
                        //Completed
                        classname = "fc-green-inverted ";
                    }
                    else if(courseStatuses.includes(4) || courseStatuses.includes(5)) {
                        //Needs approval or stopped
                        classname = "fc-orange-inverted";
                    }
                }

                if (duties[i].Unread) {
                    second_icon = "fa-envelope text-orange";
                }

                var id = duties[i].Id;
                var type = "groundDuty";
                var start = (duties[i].DutyBegin) ? duties[i].DutyBegin : ((duties[i].DutyDateS) ? duties[i].DutyDateS : duties[i].DutyDate);
                var end = duties[i].DutyEnd;
                var listViewColor = "lv-white";

                var event = {
                    _id: id,
                    title: title,
                    start: start,
                    end: end,
                    description: description,
                    icon: icon,
                    second_icon: second_icon,
                    className: classname,
                    type: type,
                    listViewColor: listViewColor
                };

                groundEvents.push(event);
            }
            return groundEvents;
        }

        /**
         * Transform Crew Routes in calendar events
         * @memberof CalendarCtrl
         * @param {array} routes The Scheduled Crew Routes 
         * @return {array} events 
         */
        function formatCrewRoutes(routes) {
            var crewRouteEvents = [];
            var now = moment.utc();
            for (var i = 0; i < routes.length; i++) {
                var description = routes[i].Route;
                // var title = (duties[i].Title)? duties[i].Title : duties[i].Duty;
                var classname = "fc-white";
                var icon = "";
                var second_icon = "";

                //TODO:: athe clean up
                // var assessmentStatus = "";
                // if (isAssessmentEnabled && routes[i].AssessmentInfo) {
                //     if (routes[i].AssessmentInfo.IsExist || routes[i].AssessmentInfo.Status == "Stored") {
                //         assessmentStatus = "Synced";
                //         //classname = "fc-green-inverted ";
                //     } else if (routes[i].AssessmentInfo.Status == "Pending") {
                //         assessmentStatus = "Pending";
                //         //classname = "fc-blue-inverted";
                //     } else if (routes[i].AssessmentInfo.Status == "Draft") {
                //         assessmentStatus = "Draft";
                //         //classname = "fc-orange-inverted";
                //     } else if (routes[i].AssessmentInfo.Status == "Completed") {
                //         assessmentStatus = "Completed";
                //         //classname = "fc-purple-inverted";
                //     }
                // }

                //Get ground courses
                var courseStatuses = [];
                var courses = routes[i].Courses;

                courses.forEach(function (x) {
                    courseStatuses.push(x.Status)
                });

                /*Statuses
                    Completed : session has been sent
                    Outdated  :	session submission is overdue
                    Draft	  : session completion has started but not submitted
                    Pending   : session submission not yet due
                */

                var trainingStatus = "";
                if (courseStatuses.includes("Pending")) {
                    //Pending
                    trainingStatus = "Pending";

                    //Outdated
                    var dutyEnd = moment.utc(routes[i].DutyEnd);
                    var duration = moment.duration(now.diff(dutyEnd)).asHours();
                    if (duration > 1) {
                        if (courseStatuses.includes("Pending")) $scope.hasUnsetTraining = true;
                        trainingStatus = "Outdated";
                    }

                    //Draft
                    var courseIds = courses.map(x => x.CourseId);
                    var route = routes[i];

                    if (flightSessions && flightSessions.length) {
                        //TODO msis fix
                        var dutyBegin = new moment(route.DutyBegin).format("YYYY-MM-DD");
                        var dutyEnd = new moment(route.DutyEnd).format("YYYY-MM-DD");
                        var existingSessions = flightSessions.filter(s => courseIds.includes(s.courseId) && (new moment(s.day).isSame(dutyBegin) || new moment(s.day).isSame(dutyEnd) || new moment(s.day).isBetween(dutyBegin, dutyEnd)) &&
                            s.dutyDay == route.DutyDay && s.dutyNo == route.DutyNo);
                        if (existingSessions && existingSessions.some(x => !x.HasLimitedInfo && x.trainees && x.trainees.length)) {
                            //a training session with trainees exists
                            trainingStatus = "Draft";
                        }
                    }
                } else if (courseStatuses.includes("Completed")) {
                    //Completed
                    trainingStatus = "Completed";
                    classname = "fc-green-inverted ";
                }


                // Status outcome form bot assessment and training
                if (trainingStatus == "Outdated") {
                    second_icon = "fa-exclamation-triangle text-yellow second-icon-training";
                    classname = "fc-seablue-inverted";
                } else if (trainingStatus == "Draft") {
                    classname = "fc-orange-inverted";
                } else if (trainingStatus == "Pending") {
                    classname = "fc-blue-inverted";
                // } else if (assessmentStatus == "Completed" ) {
                //     classname = "fc-purple-inverted";
                } else if (trainingStatus == "Completed" ) {
                    classname = "fc-green-inverted";
                }

                if (courses && courses.length) {
                    icon = "fa-graduation-cap";
                }

                var routeIndicators = [];
                if(routes[i].RouteIndicators){
                // Swap : [RECTYPE] = 106
                // Pre-Assigned : [RECTYPE] = 1
                // Requested : [RECTYPE] = 100
                // Unfinalised : [RECTYPE] = 101
                var routeIndicatorCodes = routes[i].RouteIndicators.split(',').map(Number);
                    for (var j = 0; j < routeIndicatorCodes.length; j++) {
                        var routeIndicatorCode = "";
                        var routeIndicatorColor= "";
        
                        if(routeIndicatorCodes[j]){
        
                            if(routeIndicatorCodes[j] == 106){
                                routeIndicatorCode = "S";
                                routeIndicatorColor = "text-purple";
                            }
                            else if(routeIndicatorCodes[j] == 1){
                                routeIndicatorCode = "P";
                                routeIndicatorColor = "text-teal";
                            }
                            else if(routeIndicatorCodes[j] == 100){
                                routeIndicatorCode = "R";
                            }
                            else if(routeIndicatorCodes[j] == 101){
                                routeIndicatorCode = "U";
                                routeIndicatorColor = "text-red";
                            }
                            if( routeIndicatorCode.length >0){
                                routeIndicators.push({routeIndicatorCode:routeIndicatorCode, routeIndicatorColor: routeIndicatorColor})
                            }
                        }
                    }
                }

                // var id = routes[i].Id;
                var type = "crewRoute";
                var dutyNo = routes[i].DutyNo;
                var dutyDay = routes[i].DutyDay;
                var start = (routes[i].DutyBegin) ? routes[i].DutyBegin : ((routes[i].DutyDateS) ? routes[i].DutyDateS : routes[i].DutyDate);
                var end = routes[i].DutyEnd;
                var listViewColor = "lv-white";

                var event = {
                    // _id:id,
                    // title: title,
                    dutyNo: dutyNo,
                    dutyDay: dutyDay,
                    start: start,
                    end: end,
                    description: description,
                    icon: icon,
                    second_icon: second_icon,
                    className: classname,
                    type: type,
                    listViewColor: listViewColor,
                    routeIndicators: routeIndicators
                };

                crewRouteEvents.push(event);
            }
            return crewRouteEvents;
        }

        /**
         * Transform Crew Hotels in calendar events
         * @memberof CalendarCtrl
         * @param {array} crew hotels 
         * @return {array} events 
         */
        function formatHotels(hotels) {
            var crewRouteEvents = [];
            for (var i = 0; i < hotels.length; i++) {
                //var description = hotels[i].HotelName;
                var title = hotels[i].HotelName;
                var classname = "fc-gray-inverted";

                var icon = "fa-bed";
                var second_icon = "";
                // var id = routes[i].Id;
                var type = "hotel";
                var start = moment(hotels[i].DutyDate).endOf('day').toJSON();
                // var end = hotels[i].DutyDate;
                var listViewColor = "lv-white";

                var event = {
                    // _id:id,
                    title: title,
                    start: start,
                    end: start,
                    //description:description,
                    icon: icon,
                    second_icon: second_icon,
                    className: classname,
                    type: type,
                    listViewColor: listViewColor
                };

                crewRouteEvents.push(event);
            }
            return crewRouteEvents;
        }

        /** Removes manual training entry */
        function removeManualEntry(groundDuty) {
            GroundDutyFactory.removeGroundDuty(groundDuty);
            $route.reload();
        }

        /**
         * Removes manual flight training entry 
         * @param {*} dutyNo 
         * @param {*} dutyDay 
         */
        function removeFlightTrainingManualEntry(dutyNo, dutyDay) {
            CrewRouteFactory.removeFlightTraining(dutyNo, dutyDay);
            setupView();
            $route.reload();
        }

        function removePendingGDEntry(groundDuty){
            $scope.totalIncompleteGD.find(x => x.Id == groundDuty).isManualEntry = false;
            GroundDutyFactory.removeGroundDuty(groundDuty);
            return $scope.totalIncompleteGD;          
        }

        function removePendingFlightEntry(dutyNo, dutyDay){
            $scope.totalIncompleteFlightDuties.find(x => x.FlightId == dutyNo).isManualEntry = false;
            return $scope.totalIncompleteFlightDuties;    
        }

        /**
         * Open Synch Modal
         * @memberof CalendarCtrl
         */
        function openSynch() {
            //store last time the sync dialog was displayed
            SyncLogFactory.setLastShow();

            openSynchModal();
        }

        function openSynchModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgSynch.html',
                controller: 'SynchCtrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });

            modalInstance.result.then(function (synchresult) {
                //refresh the view after a successful sync
                if (!synchresult == 'cancel') {
                    $scope.setupView(true);
                }
            }, function () { });
        }

        function openMandatoryModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgMandatory.html',
                controller: 'MandatoryModalCtrl',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: { mandatoryUnread: $scope.mandatoryUnread }
            });
        }

        /**
         * Open the "Add a flight" Modal
         * @memberof CalendarCtrl
         */
        function addFlight() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgAddFlight.html',
                controller: 'AddFlightCtrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });
        }

        /**
         * Open the "Search Ground Duties" Modal
         * @memberof CalendarCtrl
         */
        function searchPastGroundDuties() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgSearchGroundDuties.html',
                controller: 'SearchPastGDCtrl',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            });
        }

        function acknowledge() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgAcknowledgeChanges.html',
                controller: 'AcknowledgeModalCtrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });
        }


        /**
         * Gets showExpiriesAlert value
         * @memberof calendarNotifications
         */
        function showExpiriesAlertCalendar() {
            return ExpiriesFactory.showExpiriesAlert();
        }

        /**
         * Gets showSubmissionDeadlineAlert value
         * @memberof calendarNotifications
         */
        function showSubmissionDeadlineAlertCalendar() {
            return RequestFactory.showSubmissionDeadlineAlert();
        }

        function showCheckInAction() {
            var retVal = false;
            var checkInInfo = CheckInFactory.getCheckInInfoFromStorage();
            if (checkInInfo && checkInInfo.AimsId > 0) {
                var now = moment.utc();

                //Fetch FROM
                //Convert from Date UTC to Moment UTC

                var std = moment.utc(checkInInfo.STD);
                var minFetchTime = moment(std).add(-2, 'hours');

                //Fetch UNTIL    
                var maxFetchTime = moment(std).add(10, 'minutes');

                var isAfter = now.isAfter(minFetchTime);
                var isBefore = now.isBefore(maxFetchTime);

                if (isAfter && isBefore) {
                    retVal = true;
                }

                //console.log({"isAfter":isAfter, "isBefore": isBefore, "now":now, "std":std, "minFetchTime":minFetchTime,"maxFetchTime":maxFetchTime});

            }
            return retVal;
        }

        function preparePasswordExpiryData() {
            //update PasswordExpiry scope:
            var user = UserFactory.getUser();
            if(user && user.passwordLastChangeDate){
                
                var today = new Date();
                var lastChangeDate = new Date(user.passwordLastChangeDate);
                var expirationDate =  lastChangeDate.AddDays(90);
                // how many days until duty date
                var diffDays = Date.DifferenceInDays(today.trimTime(), expirationDate.trimTime());
            
                $scope.passwordExpiry = {
                    showAlert: diffDays >= 0 && diffDays <= 14,
                    lastChange: lastChangeDate,
                    daysLeft: diffDays  
                };
            }
        }

        /**
         * Shows the bootbox for schedule acknowledge reminder
         * @memberof calendarNotifications
         */
        function showReminderModal() {

            var showScheduleChangesReminder = ScheduleAcknowledgeFactory.showScheduleChangesModal();
            var showExpiriesReminder = ExpiriesFactory.showExpiriesModal();
            var showSubmissionDeadlineReminder = RequestFactory.showSubmissionDeadlineModal();
            var showSaAssessmentReminder = SaFeedbackInfoFactory.showSaAssessmentReminderModal();

            if (showScheduleChangesReminder || showExpiriesReminder || showSubmissionDeadlineReminder || showSaAssessmentReminder) {

                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgReminderModal.html',
                    controller: 'ReminderModalCtrl',
                    size: 'md',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        showScheduleChangesReminder: function () {
                            return showScheduleChangesReminder;
                        },
                        showExpiriesReminder: function () {
                            return showExpiriesReminder;
                        },
                        showSubmissionDeadlineReminder: function () {
                            return showSubmissionDeadlineReminder;
                        },
                        showSaAssessmentReminder: function () {
                            return showSaAssessmentReminder;
                        }
                    }
                });
            }
        }
        
        function showExpiredExpiriesAlertCalendar() {
            return ExpiriesFactory.showExpiredExpiriesAlert();

        }

        /**
         * Open Check in Modal
         * @memberof CalendarCtrl
         */
        function openCheckInModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgCheckIn.html',
                controller: 'CheckInModalCtrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            });
        }


        /**
         * Redirect to flight Info
         * @memberof CalendarCtrl
         */
        function gotoFlightInfo(FlightId) {
            $location.path('/flightinfo/' + FlightId);
        }

        /**
         * Redirect to groundDuty Info
         * @memberof CalendarCtrl
         */
        function gotoGroundDutyInfo(GroundDutyId) {
            $location.path('/groundDuty/' + GroundDutyId);
        }

         /**
         * Redirect to crewRoute Info
         * @memberof CalendarCtrl
         */
        function gotoCrewRouteInfo(dutyNo, dutyDay) {
            $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
        }

        /**
         * Redirect to crewRoute Info
         * @memberof CalendarCtrl
         */
        function gotoCrewRouteInfo(dutyNo, dutyDay) {
            $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
        }

        /**
         * Redirect to Library Info with filter enabled
         * @memberof CalendarCtrl
         */
        function gotoUnreadMemos() {
            $location.path('/memos/unread');
        }

        /**
         * Redirect to messages
         * @memberof CalendarCtrl
         */
        function gotoMessages() {
            $location.path('/messages/');
        }

        /**
         * Redirect to leaves
         * @memberof CalendarCtrl
         */
        function gotoLeaves() {
            $location.path('/leaverequest/');
        }
    }
})();